import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
  } from "reactstrap";
const ModaMobileLogin = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const isMobile = window.innerWidth < 650;
      setShowModal(isMobile);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleClose = () => setShowModal(false);

  return (
    <Modal isOpen={showModal} toggle={handleClose}>
      <ModalHeader closeButton>
        <span>Aviso</span>
      </ModalHeader>
      <ModalBody>
        Para uma melhor experiência, recomendamos acessar este sistema a partir de um computador.
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={handleClose}>
          Entendi
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModaMobileLogin;
